import styles from './linkInfoCard.module.scss';

export interface LinkInfoCardProps {
    children: React.ReactNode;
    detailsBlock?: React.ReactNode;
}

export default function LinkInfoCard({ children, detailsBlock }: LinkInfoCardProps) {
    return (
        <nav className={styles.container} data-cy="link-info-card-container">
            <ul className={styles.itemsWrapper}>{children}</ul>

            {detailsBlock && <div className={styles.details}>{detailsBlock}</div>}
        </nav>
    );
}
